import { PreloaderComponent } from "appworks/components/preloader/preloader-component";
import { FileLocation } from "appworks/config/asset-config-schema";
import { Layers } from "appworks/graphics/layers/layers";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { deviceInfo } from "appworks/utils/device-info";
import { gameLayers, LayerNames } from "game-layers";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

export class TGRPreloaderComponent extends PreloaderComponent {

    private loaderMask: Sprite;
    private loaderTextAlt: Text;

    public start(files: FileLocation[]) {
        super.start(files);

        this.showHidePreloaderMessgae();

        this.onProgress.add((perc) => this.onUpdateProgress(perc));

        const menusLayer: Layers = Layers.get(LayerNames.Menus);

        this.loaderTextAlt = menusLayer.getText("loader_text_alt");
        this.loaderMask = menusLayer.getSprite("loader_bar_mask");
        this.loaderTextAlt.mask = this.loaderMask;
        menusLayer.container.setChildIndex(this.loaderTextAlt, menusLayer.container.children.length - 1);
    }

    public loadComplete(): Contract<any> {
        this.onProgress.remove((perc) => this.onUpdateProgress(perc));

        const dontShow: boolean = (deviceInfo.isDesktop && Services.storage.getBoolean("epic-tgr-dsa")) || false;
        if (dontShow) {
            return super.loadComplete();
        }
        return new Sequence([
            () => gameLayers.Menus.setScene("bet_screen", () => this.showHidePreloaderMessgae()),
            () => super.loadComplete()
        ]);
    }

    protected showHidePreloaderMessgae(): void {
        const preloaderConfig = PartnerConnectManager.getConfig().settings.preloader;

        let hide: boolean = true;
        if (preloaderConfig.hasMessage) {
            Services.jurisdiction.setMinPreloaderTime(preloaderConfig.delay * 1000);
            if (preloaderConfig.message) {
                hide = false;
                gameLayers.Menus.getText("jurisdiction_message").text = preloaderConfig.message;
            }
        }

        if (hide) {
            gameLayers.Menus.getSprite("ukgc_logo").visible = false;
            gameLayers.Menus.getShape("btm_shape").visible = false;
            gameLayers.Menus.getText("jurisdiction_message").visible = false;
        }
    }

    private onUpdateProgress(percent: number): void {
        this.loaderTextAlt.text = Services.translations.get("prl.loa", { PROGRESS: Math.round(percent * 100) });
    }
}
